import React from 'react';
import { RecruitmentOverview } from '@/Models/RecruitmentOverview';
import UIStrings from '@/Utils/UIStrings';
import AssessmentInfo from './AssessmentInfo';
import BigStatusCounter from './components/BigStatusCounter';

interface RecruitmentListItemBodyProps {
    recruitment: RecruitmentOverview;
}

function RecruitmentListItemBody({ recruitment }: RecruitmentListItemBodyProps): React.JSX.Element {
    const { hasPersonality, hasAptitude, hasSkills, hasEmotionalIntelligence, statusesCount, detailedAISearchCounter } =
        recruitment;

    const { invitedCount, interviewingCount, hiredCount, completedCount } = statusesCount;

    const { totalIdentified, totalShortlistedAndContacted, totalShortlistedAndResponded } = detailedAISearchCounter;

    return (
        <div className="flex w-full flex-row flex-wrap gap-2">
            <div className="min-w-0 flex-1">
                <BigStatusCounter status={UIStrings.Identified} count={totalIdentified} />
            </div>
            <div className="min-w-0 flex-1">
                <BigStatusCounter status={UIStrings.Contacted} count={totalShortlistedAndContacted} />
            </div>
            <div className="min-w-0 flex-1">
                <BigStatusCounter status={UIStrings.Responded} count={totalShortlistedAndResponded} />
            </div>
            <div className="min-w-0 flex-1">
                <BigStatusCounter status={UIStrings.Applicants} count={invitedCount} />
            </div>
            <div className="min-w-0 flex-4">
                <AssessmentInfo
                    hasPersonality={hasPersonality}
                    hasAptitude={hasAptitude}
                    hasSkills={hasSkills}
                    hasEmotionalIntelligence={hasEmotionalIntelligence}
                    completedCount={completedCount}
                />
            </div>
            <div className="min-w-0 flex-1">
                <BigStatusCounter status={UIStrings.Interviewing} count={interviewingCount} />
            </div>
            <div className="min-w-0 flex-1">
                <BigStatusCounter status={UIStrings.Hired} count={hiredCount} />
            </div>
        </div>
    );
}

export default RecruitmentListItemBody;
